// extracted by mini-css-extract-plugin
export default {"file-new-button":"style_file-new-button__DCMTs","file-new-button-list":"style_file-new-button-list__yU5NH","file-new-button-item":"style_file-new-button-item__OHsNr"};